"use strict";(self.webpackChunkdashboard451=self.webpackChunkdashboard451||[]).push([[541],{8535:(C,h,e)=>{e.d(h,{YO:()=>f});var d=e(28568),s=e(57123),p=e(69238),u=e(97020),g=e(76634),n=e(24284);let f=(()=>{class r{static{this.\u0275fac=function(m){return new(m||r)}}static{this.\u0275mod=n.$C({type:r})}static{this.\u0275inj=n.G2t({imports:[d.MD,p.Cn,u.uc,s.Hl,g.AC]})}}return r})()},20295:(C,h,e)=>{e.d(h,{GG:()=>B,hj:()=>w,yV:()=>A,Tp:()=>l});var d=e(23673),s=e(38939);const p=(0,d.$p)((0,s.VP)("[Mappings] Request Get All")),u=(0,s.VP)("[Mappings API] Success Get All",(0,s.xk)()),g=(0,s.VP)("[Mappings API] Fail Get All",(0,s.xk)());var n=e(21152),f=e(99388),r=e(76014),P=e(6215),v=e(32479),m=e(17862),i=e(24284);const y=(0,e(4163).p)({selectId:t=>t.slug}),G=y.getInitialState({loading:!1,loaded:!1}),j=(0,s.vy)(G,(0,s.on)(p,t=>t.loaded?t:{...t,loading:!0}),(0,s.on)(u,(t,{regular:c,custom:a})=>y.setAll([...c,...a],{...t,loaded:!0,loading:!1})),(0,s.on)(g,t=>({...t,loaded:!1,loading:!1}))),$=new i.nKC("Mappings Registered Reducers"),K=[{provide:$,useValue:j}],V="mappings",M=(0,s.UX)(V),O=(0,s.Mz)(M,t=>t.loaded),E=(0,s.Mz)(M,t=>t.loading),{selectEntities:R,selectAll:F}=y.getSelectors(M),l={selectLoading:E,selectLoaded:O,selectCustomFields:(0,s.Mz)(F,t=>t.filter(c=>"system"!==c.owner)),selectRegularFields:(0,s.Mz)(F,t=>t.filter(c=>"system"===c.owner)),selectEntities:R,selectAll:F};var I=e(92281);const z=I.J1`
  query GetMappings {
    regularFields {
      guid
      slug
      notes
      owner
      map
      parent
      data_type
      form_attributes {
        field_type
        label
        help_text
        default
        input_widget
        notes
        data_source
        data_source_text
        data_source_value
        options {
          text
          value
        }
      }
    }
    customFields {
      guid
      slug
      notes
      owner
      map
      parent
      data_type
      form_attributes {
        field_type
        label
        help_text
        default
        input_widget
        notes
        data_source
        data_source_text
        data_source_value
        options {
          text
          value
        }
      }
    }
  }
`;let D=(()=>{class t{constructor(a,o,x){this.store=a,this.actions$=o,this.apollo=x,this.loaded$=this.store.pipe((0,s.Lt)(l.selectLoaded)),this.getAll$=(0,n.EH)(()=>this.actions$.pipe((0,n.gp)(p),(0,d.PO)(this.loaded$,this.store),(0,P.n)(()=>this.getMappings().pipe((0,v.T)(({regular:L,custom:J})=>u({regular:L,custom:J})),(0,m.W)(L=>(0,f.of)(g({error:L})))))))}getMappings(){const a=new Set(["user-education-prefered-major-guid","user-applications-plan-essay-file","user-applications-term-housing","user-applications-previous-semester","user-password","user_groups"]);return this.apollo.query({query:z}).pipe((0,d.xx)(o=>o?.regularFields&&o?.customFields),(0,v.T)(o=>({regular:(o.data?.regularFields||[]).filter(x=>!a.has(x.slug)),custom:o.data?.customFields||[]})),(0,r.s)(1))}static{this.\u0275fac=function(o){return new(o||t)(i.KVO(s.il),i.KVO(n.En),i.KVO(I.Ic))}}static{this.\u0275prov=i.jDH({token:t,factory:t.\u0275fac})}}return t})();var W=e(4255);let A=(()=>{class t{constructor(a){this.store=a,this.loading$=this.store.pipe((0,s.Lt)(l.selectLoading)),this.loaded$=this.store.pipe((0,s.Lt)(l.selectLoaded)),this.entities$=this.store.pipe((0,s.Lt)(l.selectEntities)),this.list$=this.store.pipe((0,s.Lt)(l.selectAll))}load(){this.store.dispatch(p())}static{this.\u0275fac=function(o){return new(o||t)(i.KVO(s.il))}}static{this.\u0275prov=i.jDH({token:t,factory:t.\u0275fac,providedIn:"root"})}}return t})();function X(t){return(0,W.IX)(["[Mappings API]","[Mappings]"])(t)}let w=(()=>{class t{static{this.\u0275fac=function(o){return new(o||t)}}static{this.\u0275mod=i.$C({type:t})}static{this.\u0275inj=i.G2t({providers:[A,K],imports:[s.md.forFeature(V,$,{metaReducers:[X]}),n.Vm.forFeature([D])]})}}return t})(),B=(()=>{class t{constructor(a){this.mappings=a}resolve(){this.mappings.load()}static{this.\u0275fac=function(o){return new(o||t)(i.KVO(A))}}static{this.\u0275prov=i.jDH({token:t,factory:t.\u0275fac,providedIn:"root"})}}return t})()}}]);